<template>
    <div class="particles">
        <div :id="particlesId"></div>
    </div>
</template>

<script>
require('particles.js')
export default {
  props: {
    particlesId: null
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      particlesJS(this.particlesId, {
        'particles': {
          'number': {
            'value': 80,
            'density': {
              'enable': true,
              'value_area': 1000
            }
          },
          'color': {
            'value': ['#005bac', '#f58220']
          },
          'shape': {
            'type': 'circle',
            'stroke': {
              'width': 0,
              'color': '#fff'
            },
            'polygon': {
              'nb_sides': 5
            },
            'image': {
              'src': 'img/github.svg',
              'width': 100,
              'height': 100
            }
          },
          'opacity': {
            'value': 0.3,
            'random': false,
            'anim': {
              'enable': false,
              'speed': 1,
              'opacity_min': 0.1,
              'sync': false
            }
          },
          'size': {
            'value': 2,
            'random': true,
            'anim': {
              'enable': false,
              'speed': 40,
              'size_min': 0.1,
              'sync': false
            }
          },
          'line_linked': {
            'enable': true,
            'distance': 120,
            'color': '#619ed7',
            'opacity': 0.4,
            'width': 2
          }
        },
        'interactivity': {
          'detect_on': 'canvas',
          'events': {
            'onhover': {
              'enable': true,
              'mode': 'grab'
            },
            'onclick': {
              'enable': false
            },
            'resize': true
          },
          'modes': {
            'grab': {
              'distance': 140,
              'line_linked': {
                'opacity': 1
              }
            },
            'bubble': {
              'distance': 400,
              'size': 40,
              'duration': 2,
              'opacity': 8,
              'speed': 3
            },
            'repulse': {
              'distance': 200,
              'duration': 0.4
            },
            'push': {
              'particles_nb': 4
            },
            'remove': {
              'particles_nb': 2
            }
          }
        },
        'retina_detect': true
      })
    }
  }
}
</script>

<style scoped>
.particles{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}
</style>
